<template>
    <div :id="`lm-form-comment-builder-ui-${id}`" class="row">
      <LmTextInput
        :id="`prefix-${id}`"
        class="col-12 col-md-6"
        v-model="component.componentProps.commentPrefix"
        @input="$emit('input', component)"
        :label="$t('prefix')"
        :placeholder="$t('prefix')"
      />
      <LmTextInput
        :id="`comment-${id}`"
        class="col-12 col-md-6"
        v-model="component.componentProps.comment"
        @input="$emit('input', component)"
        :label="$t('comment')"
        :placeholder="$t('comment')"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
export default {
  data () {
    return {
      component: {}
    }
  },
  components: {
    LmTextInput
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    componentData: {
      type: Object,
      default: () => ({
        componentProps: {
          comment: '',
          commentPrefix: ''
        }
      })
    }
  },
  created () {
    this.component = this.componentData
  }
}
</script>
